export * from '../../../../../apps/crm/src/pages/products/components/products-list';
